import React, { useEffect, useState } from "react";
import { Avatar } from "primereact/avatar";
import "./AshaIndividualView.scss";
import { useDispatch, useSelector } from "react-redux";
import * as masterSelectors from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import {
  fetchAshaProfile,
  fetchAshaSchemes,
  fetchIncentiveDetails,
} from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import AshaSchemeView from "../AshaSchemeView/AshaSchemeView";
import AshaProfileView from "../AshaProfileView/AshaProfileView";
import SendReminderView from "../../../../Shared/Component/SendReminder/SendReminderView";
import IncentiveActivityDetails from "../IncentiveActivity/IncentiveActivityDetails";
import ReusableTabView from "../../../../Shared/Component/CustomReusableTab/ReusableTabView";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../ChangeLanguage/LanguageProvider";
const AshaIndividualView = ({
  ashaId,
  chosenActiveIndex = 0,
  isStatus,
  name,
  inactiveSince,
}) => {
  const { t } = useTranslation("Incentive");
  const ashaProfile = useSelector(masterSelectors.getAshaProfile);
  const allAshaScheme = useSelector(masterSelectors.getAshaScheme);
  const incentiveData = useSelector(masterSelectors.getIncentiveData);
  const [incentive, setIncentive] = useState(incentiveData);
  const [profile, setProfile] = useState(ashaProfile);
  const [allSchemes, setAllSchemes] = useState({});
  const dispatch = useDispatch();
  const { selectedLanguageId } = useLanguage();
  useEffect(() => {
    dispatch(fetchAshaProfile(ashaId, selectedLanguageId));
    dispatch(fetchIncentiveDetails(ashaId, selectedLanguageId));
    dispatch(fetchAshaSchemes(ashaId, selectedLanguageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ashaId]);
  useEffect(() => {
    setProfile(ashaProfile);
  }, [ashaProfile]);

  useEffect(() => {
    setAllSchemes(allAshaScheme);
  }, [allAshaScheme]);

  useEffect(() => {
    setIncentive(incentiveData);
  }, [incentiveData]);
  const tabs = [
    {
      header: t("ProfileDetails"),
      content: (
        <AshaProfileView ashaId={ashaId} profile={profile} status={isStatus} />
      ),
    },
    {
      header: t("IncentiveActDetails"),
      content: (
        <IncentiveActivityDetails ashaId={ashaId} incentiveData={incentive} />
      ),
    },

    {
      header: t("Schemes"),
      content: <AshaSchemeView allAshaScheme={allSchemes} />,
    },
  ];
  const splitName = name.split(" ");
  const label =
    splitName.length > 1
      ? `${splitName[0].charAt(0)}${splitName[1].charAt(0)}`
      : splitName[0].slice(0, 2).toUpperCase();
  return (
    <div className="asha-card">
      <div className="flex align-items-center justify-content-between">
        <div className="flex align-items-center">
          <Avatar
            label={label}
            className="mr-2"
            size="large"
            style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
            shape="circle"
          />
          <p className="text-xl font-light ml-2">{name}</p>
        </div>
        <div className="flex flex-row">
          <div className="flex mr-2 align-items-center justify-content-center text-red-400">
            {isStatus === "Inactive" || isStatus === "inactive"
              ? `Inactive since : ${inactiveSince}`
              : ""}
          </div>
          <div className="flex">
            <SendReminderView ashaIds={[ashaId]} isDisabled={false} />
          </div>
        </div>
      </div>
      <ReusableTabView tabs={tabs} />
    </div>
  );
};

AshaIndividualView.propTypes = {
  ashaId: PropTypes.string.isRequired,
  chosenActiveIndex: PropTypes.number,
};

export default AshaIndividualView;
